import type {
  WhatsNewContentCollection,
  WhatsNewSkeleton,
  WhatsNewTeaserEntry,
} from '@fordeer/ui-components'
import { FordeerApp, getActiveWhatsNewTeasers } from '@fordeer/ui-components'
import { createClient } from 'contentful'

export type InvoiceContentfulClient = ReturnType<typeof createClient>

export type InvoiceWhatsNewEntryVM = WhatsNewTeaserEntry

export async function fetchInvoiceWhatsNewEntries(
  client: InvoiceContentfulClient,
): Promise<WhatsNewContentCollection | null> {
  const response = (await client.getEntries<WhatsNewSkeleton>({
    content_type: 'whatsNew',
    include: 2,
    limit: 100,
  })) as unknown as WhatsNewContentCollection

  return response
}

export const getInvoiceWhatsNewEntries = (
  client: InvoiceContentfulClient,
): Promise<InvoiceWhatsNewEntryVM[]> =>
  getActiveWhatsNewTeasers({
    app: FordeerApp.Invoice,
    getWhatsNewEntries: () => fetchInvoiceWhatsNewEntries(client),
  })
